var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-tree-node" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "context-menu",
            rawName: "v-context-menu",
            value: { params: _vm.params, data: _vm.treeMenu },
            expression: "{ params: params, data: treeMenu }",
          },
        ],
        staticClass: "tree-name",
        attrs: { id: _vm.data._id + "_navtree_nodeid" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.currNodeChange.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "span",
          [
            !_vm.$navTreeCtrl.icons
              ? [
                  _vm.data[_vm.$navTreeCtrl.defaultProps.children] !==
                    undefined && _vm.$navTreeCtrl.showIcon
                    ? _c("i", {
                        staticClass: "iconfont",
                        class: [
                          _vm.node.expanded ? "icon-dakai" : "icon-wenjianjia",
                        ],
                      })
                    : _vm.$navTreeCtrl.showIcon
                    ? _c("i", { staticClass: "iconfont icon-shiyongwendang" })
                    : _vm._e(),
                  _vm._t(
                    "nodeLabel",
                    function () {
                      return [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.dsf.safe.xss(
                                _vm.data[_vm.$navTreeCtrl.defaultProps.label]
                              )
                            ),
                          },
                        }),
                      ]
                    },
                    { data: _vm.data }
                  ),
                ]
              : _vm._l(
                  _vm.$navTreeCtrl.icons.filter(function (icon) {
                    return _vm.getIconClass(icon, _vm.node)[0] != ""
                  }),
                  function (icon, iconI) {
                    return _c("i", {
                      key: iconI,
                      staticClass: "iconfont",
                      class: _vm.getIconClass(icon, _vm.node),
                      style: { color: icon.color },
                    })
                  }
                ),
            _vm._t(
              "nodeLabel",
              function () {
                return [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.dsf.safe.xss(
                          _vm.data[_vm.$navTreeCtrl.defaultProps.label]
                        )
                      ),
                    },
                  }),
                ]
              },
              { data: _vm.data }
            ),
          ],
          2
        ),
        _vm.buttons.length > 0
          ? _c("DsfButtonBar", {
              staticClass: "ds-no-padding edit-span",
              attrs: {
                "render-button": _vm.$navTreeCtrl.renderRowButton,
                "max-number": _vm.$navTreeCtrl.rowButtonsMaxNumber,
                "more-button-text": _vm.$navTreeCtrl.rowButtonsMoreText,
                "more-button-style": _vm.$navTreeCtrl.rowButtonsMoreStyle,
                buttons: _vm.buttons,
                "emit-prefix": "row-button",
                local: _vm.data,
                size: "small",
                align: "center",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }